import * as yup from 'yup';

export default yup.object().shape({
  slideNumber: yup
    .number()
    .typeError('Please enter a valid number')
    .required('Slide number is required')
    .min(1, 'Minimum number of slides is 1')
    .max(40, 'Maximum number of slides is 40'),
  sections: yup.array().of(
    yup.object().shape({
      title: yup.string().required('Section title is required'),
    }),
  ),
  doc: yup.string().required('Content is required'),
  contentStyle: yup.string().required(),
});
